var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3067 23.804C15.0723 24.1678 14.7358 24.4697 14.331 24.6796C13.9261 24.8895 13.4672 25 13 25C12.5328 25 12.0739 24.8895 11.669 24.6796C11.2642 24.4697 10.9277 24.1678 10.6933 23.804M21 8.20128C21 6.29138 20.1571 4.45971 18.6569 3.1092C17.1566 1.7587 15.1217 1 13 1C10.8783 1 8.84344 1.7587 7.34315 3.1092C5.84285 4.45971 5 6.29138 5 8.20128C5 16.6028 1 19.0032 1 19.0032H25C25 19.0032 21 16.6028 21 8.20128Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.0a442e14c60ed4283f037a4656beaff1.svg";
export { ForwardRef as ReactComponent };